export default __webpack_public_path__ + "static/media/arma7.4a81ca10.jpg";